// Dashboards hub entry for /dashboards/coverage. Self-contained (no
// imports) so the hub can collect every entry with import.meta.glob.
export const dashboardEntry = {
  key: 'coverage',
  title: 'Coverage',
  description: 'Find what X-One can’t see: disconnected tools, devices without protection and assets nobody manages.',
  route: '/dashboards/coverage',
  icon: 'radar',
  apps: ['posture', 'surface', 'xes', 'insider'],
  // Every source behind it (connections, devices, inventory) is
  // owner/admin only in its own app.
  adminOnly: true,
} as const;
